/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Generate_PasswordInputs */

const en_admin_create_generate_password = /** @type {(inputs: Admin_Create_Generate_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Password`)
};

const de_admin_create_generate_password = /** @type {(inputs: Admin_Create_Generate_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort generieren`)
};

/**
* | output |
* | --- |
* | "Generate Password" |
*
* @param {Admin_Create_Generate_PasswordInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_generate_password = /** @type {((inputs?: Admin_Create_Generate_PasswordInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Generate_PasswordInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_generate_password(inputs)
	return en_admin_create_generate_password(inputs)
});